import React from 'react';
import tw from 'twin.macro';
import { Outlet } from 'react-router-dom';
import Header from 'components/headers/light.js';

const MainContent = tw.main`pt-32`;

const HeaderOnlyLayout = () => {
	return (
		<>
			<Header />
			<MainContent>
				<Outlet />
			</MainContent>
		</>
	);
};

export default HeaderOnlyLayout;
